import ms from 'ms';
import DocumentTitle from 'react-document-title';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import MembershipsIndex from 'hb-react/shared/apps/Memberships/containers/MembershipsIndex';
import MembershipsV2App from 'hb-react/shared/apps/Memberships/startup/MembershipsV2App';
import useGet from 'hb-react/shared/hooks/useGet';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

const MembershipsV2AppWrapper = () => {
  const topicContext = useTopicContext();
  const { currentNetwork } = useDefaultAppContexts();

  const { topic } = useGet(Routes.topics_topic_path(topicContext.topicId), {
    enabled: !topicContext.standalone,
    staleTime: ms('5m'),
  });

  const menuName = usePageMenuName(PAGES.MEMBERSHIPS, __('Memberships'));

  const config = {
    custom: {
      page: {
        withHeader: false,
        menu_name: menuName,
      },
      readOnly: false,
    },
  };

  if (topicContext.standalone) {
    return (
      <>
        <DocumentTitle
          title={generatePageTitle({
            title: menuName,
            networkName: getPageTitleFromNetwork(currentNetwork),
            topicName: topic?.name || topicContext.topicName,
          })}
        />

        <MembershipsIndex
          appPageConfig={currentNetwork.network_config?.custom?.page}
          topicName={topic?.name}
        />
      </>
    );
  }

  config.custom.readOnly = !topic?.full_access;

  return (
    <>
      <DocumentTitle
        title={generatePageTitle({
          title: menuName,
          networkName: getPageTitleFromNetwork(currentNetwork),
          topicName: topic?.name || topicContext.topicName,
        })}
      />

      <MembershipsV2App config={config} topicName={topic?.name} />
    </>
  );
};

const TopicMembershipsContainer = () => <MembershipsV2AppWrapper />;

export default TopicMembershipsContainer;
